/**
 * Maps generator logbooks into a format suitable for selection components.
 *
 * @param logbooks - An array of logbook objects to be mapped.
 * @returns An array of logbooks formatted for selection, including collections and their parts.
 */
export const mapGeneratorLogbooks = (logbooks: any[]) => {
  const logbooksForSelect: any[] = [];
  const seenValues = new Set<string>();

  logbooks?.forEach((item: any) => {
    if (item && item.lbtype === "collection" && item.lbname) {
      if (!seenValues.has(item.lbid)) {
        // Disabled header item
        logbooksForSelect.push({
          label: item.lbname,
          lbtype: item.lbtype,
          value: item.lbid,
          disabled: true,
        });
        seenValues.add(item.lbid);
      }

      // iterate parts of the collection
      if (item.parts) {
        item.parts.forEach((part: any) => {
          if (!seenValues.has(part.lbid)) {
            logbooksForSelect.push({
              label: String.fromCharCode(9474) + part.lbname,
              lbtype: part.lbtype,
              lbid: item.lbid,
              value: part.lbid,
              latest: part.latest,
            });
            seenValues.add(part.lbid);
          }
        });
      }
    } else {
      if (item && !seenValues.has(item.lbid) && item.lbname) {
        logbooksForSelect.push({
          label: item.lbname,
          lbtype: item.lbtype,
          value: item.lbid,
          latest: item.latest,
        });
        seenValues.add(item.lbid);
      }
    }
  });
  return logbooksForSelect;
};
